import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    root: {
      display: 'grid',
      gridTemplateAreas: '"label value"',
      gridTemplateColumns: '150px auto',
      gridColumnGap: theme.spacing(1),
      marginBottom: theme.spacing(0.75),
      '&.stacked': {
        gridTemplateAreas: '"label" "value"',
        gridTemplateColumns: 'auto',
      },
    },
    label: {
      gridArea: 'label',
      fontSize: '13px',
      fontWeight: 'bold',
      lineHeight: '19px',
      alignSelf: 'start',
      '&::after': {
        content: '": "',
      },
    },
    value: {
      display: 'flex',
      gap: '5px',
      gridArea: 'value',
      fontSize: '14px',
    },
  };
};
